import { useMsal } from "@azure/msal-react"

export function useGetUser() {
  const { accounts } = useMsal()
  return accounts[0]?.name ?? "Ukjent"
}
